import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'

// Components
import Nav from './comps/Nav';
import ScrollToTop from './comps/ScrollToTop';

// Pages
import Home from './pages/Home';
import Project from './pages/Project';
import SingleProject from './pages/SingleProject';
import Drone from './pages/Drone';
import Art from './pages/Art';
import About from './comps/About';
import Footer from './comps/Footer';

import './style/App.sass';
import './style/footer.sass';
import './style/media.sass';

import { useContext } from 'react';
import { ThemeContext } from './context/ThemeContext.tsx'

function App() {
  const { theme, setTheme } = useContext(ThemeContext)

  return (
    <div className={theme + ' App'}>
      <div id='topAnchor'></div>
      {/* <button onClick={()=> setTheme(theme == 'dark' ? 'light': 'dark')} className="theme" aria-label='Dark- and light-theme switch'></button> */}

      <Router>
        <ScrollToTop>
          <Nav />
          <main>
            <Routes>
              <Route exact path='/' element={<Home />} />
              <Route path='/projects' element={<Project />} />
              <Route path='/projects/:slug' element={<SingleProject />} />
              <Route path='/drone' element={<Drone />} />
              <Route path='/art' element={<Art />} />
              <Route path='/about' element={<About />} />

              <Route path='*' element={<Navigate to='/' />} />
            </Routes>
          </main>
          <div className='footerContainer'>
            <Footer />
          </div>
        </ScrollToTop>
      </Router>
    </div >
  );
}

export default App;
